import { render, staticRenderFns } from "./Answer.vue?vue&type=template&id=7593eb72&scoped=true"
import script from "./Answer.vue?vue&type=script&lang=js"
export * from "./Answer.vue?vue&type=script&lang=js"
import style0 from "./Answer.vue?vue&type=style&index=0&id=7593eb72&prod&scoped=true&lang=css"
import style1 from "./Answer.vue?vue&type=style&index=1&id=7593eb72&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7593eb72",
  null
  
)

export default component.exports